import { render, staticRenderFns } from "./contactsLegalList.vue?vue&type=template&id=1a2a1967&scoped=true"
import script from "./contactsLegalList.vue?vue&type=script&lang=js"
export * from "./contactsLegalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a1967",
  null
  
)

export default component.exports